var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-input',_vm._b({attrs:{"value":_vm.email,"error":_vm.$root.errorBag.email},on:{"input":_vm.updateEmail}},'text-input',{ required: _vm.required, label: _vm.showLabel },false),[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }